var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"invisible-wall",on:{"click":function($event){return _vm.$emit('update:show', false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }